/**
 * @file cn.ts
 * @path packages/utils/src/cn.ts
 * @description
 */

import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
